import {useCallback, useContext} from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {
  getPointsRate,
  pointsProgram,
  toPoints
} from '@vio/core/src/loyalty/pointsProgram'

import {PointsPriceContext} from '../PointsPriceProvider'

/** Availability does not depend on the balance: a real member can hold 0 points and still switch to them. */
export const usePointsPriceDisplay = () => {
  const {monetisation} = useBrandCapabilities()
  const {currencyCode, isOn, setIsOn} = useContext(PointsPriceContext)

  const rate = getPointsRate(currencyCode)
  const isAvailable = monetisation.hasPointsProgram && rate !== undefined
  const canEarn = isAvailable && monetisation.hasEarnedPoints

  const splitParts = useCallback(
    (amount: number) => {
      const points = toPoints(amount, currencyCode) ?? 0
      const pointsPart = Math.ceil(Math.min(points, pointsProgram.balance))
      const cashPart = rate ? Math.max(0, amount - pointsPart / rate) : amount

      return {pointsPart, cashPart}
    },
    [currencyCode, rate]
  )

  return {
    isAvailable,
    canEarn,
    isOn: isAvailable && isOn,
    setIsOn,
    splitParts,
    currencyCode
  }
}
